import { defineAction } from '~/prix'
import { z } from 'zod'
import trainingPerformedCreateAction from './trainingPerformedCreate.action.json' with { type: 'json' }
import { trainingPerformedObject } from '../trainingPerformedObject'
import { citizenObject } from '~/packages/general/citizen/citizenObject'

const trainingPerformedCreateDefinition = defineAction({
  ...trainingPerformedCreateAction,

  input: trainingPerformedObject
    .pick({
      id: true,
      trainingId: true,
      startDate: true,
      endDate: true,
      location: true,
      latitude: true,
      longitude: true,
      fullAddress: true,
      trainer: true,
      participants: true,
      hours: true,
    })
    .partial({ id: true })
    .extend({
      citizens: z.array(citizenObject.shape.id).nullish(),
    }),
  output: z.object({ id: trainingPerformedObject.shape.id }),
})

export default trainingPerformedCreateDefinition
